import { ClassNameMap, makeStyles } from '@mui/styles';

export const useCallToActionButtonStyles = (style?: Record<string, unknown>): (() => ClassNameMap<string>) =>
	makeStyles({
		root: {
			...style,
		},
	});
